
import { MedicalKnowledgeService } from "@/services/medicalKnowledge";

export async function initializeMedicalDatabase(): Promise<boolean> {
  console.log('Starting fast medical database check...');
  
  try {
    // Quick check if database has any data
    const existingData = await MedicalKnowledgeService.searchRelevantKnowledge(['test'], [], [], 1);
    
    if (existingData.length > 0) {
      console.log('Database already contains medical data');
      return true;
    }

    console.log('Database appears empty, triggering background sync...');

    // Non-blocking background sync - don't wait for completion
    Promise.all([
      MedicalKnowledgeService.triggerSync('pubmed'),
      MedicalKnowledgeService.triggerSync('trip'),
      MedicalKnowledgeService.triggerSync('openfda'),
      MedicalKnowledgeService.triggerSync('dailymed'),
      MedicalKnowledgeService.triggerSync('clinicaltrials')
    ]).then(results => {
      const successful = results.filter(result => result === true).length;
      console.log(`Background sync initiated for ${successful}/5 data sources`);
    }).catch(error => {
      console.error('Background sync error:', error);
    });

    // Return true immediately - don't block the UI
    return true;
    
  } catch (error) {
    console.error('Database initialization check failed:', error);
    return true; // Don't block the UI even on error
  }
}

// Auto-initialize on app start (non-blocking)
export async function autoInitializeIfNeeded(): Promise<void> {
  try {
    // Don't await - let it run in background
    initializeMedicalDatabase().then(initialized => {
      if (initialized) {
        console.log('Medical database check completed');
      }
    });
  } catch (error) {
    console.error('Auto-initialization error:', error);
  }
}
